import { useMemo, useState } from 'react';

import Information from '../../components/atoms/information';
import Select from '../../components/atoms/select/Select';
import { UserProfileWithCompleteSections } from '../../types/compound/progressTypes';

import './CurrentParticipantsSection.scss';

const CURRENT_PARTICIPANTS_KEY_VALUES = {
  'participant-name': 'Participant Name',
  'most-recent': 'Most recent',
  progress: 'Progress',
};

type CurrentParticipantKey = keyof typeof CURRENT_PARTICIPANTS_KEY_VALUES;

const CURRENT_PARTICIPANT_OPTIONS: { value: CurrentParticipantKey; label: string }[] = Object.entries(
  CURRENT_PARTICIPANTS_KEY_VALUES
).map(([key, value]) => ({
  value: key as CurrentParticipantKey,
  label: value,
}));

interface CurrentParticipantsSectionProps {
  currentParticipants: UserProfileWithCompleteSections[];
  totalSections: number;
}

export default function CurrentParticipantsSection({
  currentParticipants,
  totalSections,
}: CurrentParticipantsSectionProps) {
  const [sortKey, setSortKey] = useState<CurrentParticipantKey>();
  const sortedCurrentParticipants = useMemo(() => {
    switch (sortKey) {
      // case 'participant-name':
      //   return currentParticipants
      //     ? [...currentParticipants].sort((a, b) => a.firstName.localeCompare(b.firstName))
      //     : undefined;
      case 'progress':
        return currentParticipants
          ? [...currentParticipants].sort((a, b) => b.completeSections - a.completeSections)
          : undefined;
      default:
        return currentParticipants;
    }
  }, [currentParticipants, sortKey]);

  const CurrentParticipantRows = sortedCurrentParticipants?.map(userProfile => {
    return (
      <tr key={userProfile.id}>
        <td>{userProfile.firstName ?? 'User'}</td>
        <td>N/A</td>
        <td>
          {userProfile.completeSections} / {totalSections}
        </td>
      </tr>
    );
  });

  return (
    <div>
      <div className="flex items-center mb-8">
        <h2 className="text-lg font-medium">Current participants</h2>
        <Select
          options={CURRENT_PARTICIPANT_OPTIONS}
          onChange={newValue => setSortKey(newValue?.value)}
          className="ml-auto"
        />
      </div>

      <table className="table w-full">
        <thead>
          <tr>
            <th>Participant name</th>
            <th>Start date</th>
            <th>
              <Information iconClassName="ml-1" text="Sections completed / Sections in total">
                Progress
              </Information>
            </th>
          </tr>
        </thead>
        <tbody>{CurrentParticipantRows}</tbody>
      </table>
    </div>
  );
}
